import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { getLineBreak } from '../../../../common/FormatMessageComponents';
import Modal from '../../../../common/Modal';
import { Button } from '../../../../common/Button';
import GrayBox from '../../../layout/GrayBox';
import { getParsedParams, paramsKeys } from '../../../../../utils/consts/params';
import { appIdentity } from '../../../../../utils/consts/appIdentity';
import { logTvConnectionSuccess } from '../../../../../utils/analytics/tvEvents';
import AppleTVIcon from '../../../../../../assets/icons/platforms/apple-tv.svg';
import AndroidTVIcon from '../../../../../../assets/icons/platforms/android-tv.svg';
import styles from './TvConnectedModal.scss';

interface TvConnectedModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const TvConnectedModal = ({ isOpen, onClose }: TvConnectedModalProps) => {
  const navigate = useNavigate();
  const [image, setImage] = useState<string>(AppleTVIcon);

  useEffect(() => {
    const platform = getParsedParams().PLATFORM || 'unknown';

    if (getParsedParams().TV_CONNECTED === appIdentity.ANDROID) {
      setImage(AndroidTVIcon);
    }

    const params = new URLSearchParams(window.location.search);

    params.delete(paramsKeys.TV_CONNECTED);
    params.delete(paramsKeys.PLATFORM);
    void navigate({ search: params.toString() }, { replace: true });

    logTvConnectionSuccess(platform);
  }, []);

  return (
    <Modal withCloseButton isOpen={isOpen} className={styles.modal} onClose={onClose}>
      <h1 className={styles.title}>
        <FormattedMessage id="profile.tvConnectedModal.title" defaultMessage="Your device is connected!" />
      </h1>

      <GrayBox className={styles.grayBox}>
        <img src={image} alt="" width="135" height="80" className={styles.image} />

        <h3 className={styles.subtitle}>
          <FormattedMessage
            id="profile.tvConnectedModal.subtitle"
            defaultMessage="Your TV is now linked to your account. "
          />
        </h3>

        <p className={styles.text}>
          <FormattedMessage
            id="profile.tvConnectedModal.text"
            defaultMessage="Continue to complete setup and start using ClearVPN. It only takes a moment to get started."
            values={{
              br: getLineBreak(),
            }}
          />
        </p>

        <Button kind="primary" buttonSize="small" className={styles.button} onClick={onClose}>
          <FormattedMessage id="profile.tvConnectedModal.button" defaultMessage="Continue" />
        </Button>
      </GrayBox>
    </Modal>
  );
};

export default TvConnectedModal;
